<template>
  <a-modal
    title="编辑"
    width="500px"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-card :body-style="{padding: '2px 2px'}" :bordered="false">

      <a-form @submit="handleSubmit" :form="form">

        <a-form-item
          label="头像"
          :labelCol="{lg: {span: 6}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
          <span style="padding-left:10px">
            <a-avatar :src="user_avatar"/>
          </span>
        </a-form-item>

        <a-form-item
          label="用户名"
          :labelCol="{lg: {span: 6}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
          <span style="padding-left:10px" >{{ `${user_name}` }}</span>
        </a-form-item>

        <a-form-item
          label="用户昵称"
          :labelCol="{lg: {span: 6}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
          <a-input
            placeholder="请输入用户昵称"
            v-decorator="[ 'user_nickname']"
            :theDefaultValue="user_nickname" />
        </a-form-item>

        <a-form-item
          label="手机号"
          :labelCol="{lg: {span: 6}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
          <a-input
            placeholder="请输入用户手机号码"
            v-decorator="[ 'user_mobile']"
            :theDefaultValue="user_mobile" />
        </a-form-item>

        <a-form-item
          label="QQ"
          :labelCol="{lg: {span: 6}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
          <a-input
            placeholder="请输入用户QQ号码"
            v-decorator="[ 'user_qq' ]"
            :theDefaultValue="user_qq" />
        </a-form-item>

        <a-form-item
          label="邮箱"
          :labelCol="{lg: {span: 6}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
          <a-input
            placeholder="请输入用户邮箱"
            v-decorator="[ 'user_mail']"
            :theDefaultValue="user_mail" />
        </a-form-item>

        <a-form-item
          label="备注信息"
          :labelCol="{lg: {span: 6}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
          <a-input
            placeholder="请输入用户备注信息"
            v-decorator="[ 'user_comments']"
            :theDefaultValue="user_comments" />
        </a-form-item>

        <a-form-item
          label="用户角色"
          :labelCol="{lg: {span: 6}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
          <a-select placeholder="请选择用户角色" v-decorator="['role_id']" >
            <a-select-option value="0">测试用户</a-select-option>
            <a-select-option value="1">管理员</a-select-option>
            <a-select-option value="2">普通用户</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          label="用户状态"
          :labelCol="{lg: {span: 6}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
          <a-select placeholder="请选择用户状态" v-decorator="['user_status']" >
            <a-select-option value="0">禁用</a-select-option>
            <a-select-option value="1">可用</a-select-option>
          </a-select>
        </a-form-item>

      </a-form>
    </a-card>
  </a-modal>
</template>

<script>
import UploadImage from '@/components/UploadImage'
import SelectHospital from '@/components/selector/SelectHospital'
import { editData, editTaskData } from '@/api/data'
import { updateUserInfo } from '@/api/adminuser'
import { DEFAULT_IMAGE } from '@/utils/const'
import { fetchFileUrl } from '@/api/file'
import { getGenderText, getHospitalText, getUserRole } from '@/utils/const'

export default {
  name: 'EditUserModal',
  components: {
    SelectHospital
  },
  data () {
    return {
    //   image: DEFAULT_IMAGE,
      visible: false,
      uid: '',
      user_avatar: '',
      user_name: '',
      user_nickname: '',
      user_status: '',
      user_comments: '',
      user_mobile: '',
      user_qq: '',
      user_mail: '',
      role_id: '',
      //   data_id: '',
      //   hospital: '',
      //   case_name: '',
      //   case_gender: '',
      //   case_age: '',
      //   data_des: '',
      //   id: '',
      opened: false,
      form: this.$form.createForm(this),
      spinning: false

    }
  },

  methods: {
    edit (record) {
      this.visible = false
      this.opened = false
      const _this = this
      //   this.image = DEFAULT_IMAGE
      this.$nextTick(() => {
        _this.spinning = true
        // fetchFileUrl({ data_id: record.data_id }).then(res => {
        //   _this.image = res.data
        // })
        _this.visible = true
        _this.opened = true
        _this.uid = record.origin_data.uid
        _this.user_name = record.user_name
        _this.user_avatar = record.origin_data.user_avatar
        this.$nextTick(() => {
          _this.form.setFieldsValue({
            uid: record.origin_data.uid,
            user_avatar: record.origin_data.user_avatar,
            user_nickname: record.user_nickname,
            user_status: record.origin_data.user_status,
            user_comments: record.origin_data.user_comments,
            user_mobile: record.origin_data.user_mobile,
            user_qq: record.origin_data.user_qq,
            user_mail: record.origin_data.user_mail,
            role_id: record.origin_data.role_id
          })
        })
      })
    },
    noSpinning () {
      this.spinning = false
    },
    handleCancel () {
      this.visible = false
      this.opened = false
    },
    // handler
    handleOk () {
      //
      const _this = this
      this.form.validateFields((err, values) => {
        //
        if (!err) {
          const params = {
            uid: _this.uid,
            user_nickname: values.user_nickname,
            user_status: values.user_status,
            user_comments: values.user_comments,
            user_avatar: _this.user_avatar,
            user_mail: values.user_mail,
            user_qq: values.user_qq,
            role_id: values.role_id,
            user_mobile: values.user_mobile
            // source_id: this.$refs.hospital.value || this.$refs.hospital.theDefaultValue,
            // data_des: values.data_des,
            // case_gender: values.case_gender,
            // case_age: values.case_age
          }
          var request = updateUserInfo
          //   if (_this.$store.getters.isProjectCreater) request = editTaskData
          request(params).then(res => {
            _this.$message.success('修改成功')
            _this.$emit('dataChanged')
            _this.visible = false
            _this.opened = false
          }).catch((err) => {
            _this.$message.error('修改失败')
          })
        }
      })
    }
  }
}
</script>
